(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_review-carousel"] && !Shopify.designMode) return;
  try {
    class WmReviewCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.wm-rc__track');
      if (!track) return;

      // Clone items for seamless infinite loop (replaces the Liquid dual-pass approach)
      const items = Array.from(track.querySelectorAll('.wm-rc__item'));
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        const img = clone.querySelector('img');
        if (img) img.alt = '';
        track.appendChild(clone);
      });

      let dragging = false;
      let startX = 0;
      let scrollStart = 0;

      this.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        scrollStart = this.scrollLeft;
        this.setPointerCapture(e.pointerId);
        track.style.animationPlayState = 'paused';
      });

      this.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        this.scrollLeft = scrollStart - (e.clientX - startX);
      });

      const stop = (e) => {
        if (!dragging) return;
        dragging = false;
        this.releasePointerCapture?.(e.pointerId);
        track.style.animationPlayState = '';
      };

      this.addEventListener('pointerup', stop);
      this.addEventListener('pointercancel', stop);
    }
  }

  if (!customElements.get('wm-review-carousel')) {
    customElements.define('wm-review-carousel', WmReviewCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wm-industries-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  class WmIndustriesCarousel extends HTMLElement {
    connectedCallback() {
      var self = this;
      requestAnimationFrame(function () {
        self._init();
      });
    }

    disconnectedCallback() {
      this._removeListeners();
    }

    _init() {
      var section = this.closest('.wm-section');
      if (!section) return;

      this._cards  = section.querySelectorAll('[data-industry-card]');
      this._prev   = this.querySelector('[data-ic-prev]');
      this._next   = this.querySelector('[data-ic-next]');
      this._fill   = this.querySelector('[data-ic-fill]');
      this._active = 0;

      if (!this._cards.length) return;

      this._setActive(0);

      this._boundPrev        = this._goPrev.bind(this);
      this._boundNext        = this._goNext.bind(this);
      this._boundSectionLoad = this._handleSectionLoad.bind(this);

      if (this._prev) this._prev.addEventListener('click', this._boundPrev);
      if (this._next) this._next.addEventListener('click', this._boundNext);

      document.addEventListener('shopify:section:load', this._boundSectionLoad);
    }

    _removeListeners() {
      if (this._prev && this._boundPrev) this._prev.removeEventListener('click', this._boundPrev);
      if (this._next && this._boundNext) this._next.removeEventListener('click', this._boundNext);
      if (this._boundSectionLoad) document.removeEventListener('shopify:section:load', this._boundSectionLoad);
    }

    _goPrev() {
      this._active = (this._active - 1 + this._cards.length) % this._cards.length;
      this._setActive(this._active);
    }

    _goNext() {
      this._active = (this._active + 1) % this._cards.length;
      this._setActive(this._active);
    }

    _setActive(index) {
      var total = this._cards.length;
      this._cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
      });
      if (this._fill) {
        var pct = total > 1 ? index / (total - 1) : 0;
        this._fill.style.transform = 'scaleX(' + pct + ')';
      }
    }

    _handleSectionLoad(event) {
      var section = event.target;
      if (section && section.dataset.sectionType === 'wm-industries') {
        this._removeListeners();
        this._init();
      }
    }
  }

  if (!customElements.get('wm-industries-carousel')) {
    customElements.define('wm-industries-carousel', WmIndustriesCarousel);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
